// Step 2
// Personal user Details

import React, { useEffect, useCallback } from "react";
import InputFields from "../../common/input";
import CardAsset from "../UI/card-asset";
import StepsIndicator from "../steps-indicator";
import NextButton from "../../components/UI/next-button";
import BackButton from "../UI/back-button";
import AllLoginNotification from "../../components/UI/all-login-notif-card";
import Cookies from "js-cookie";
import Layout from "../layout";
import ErrorBoundary from "../errors/ErrorBoundary";
import ApiService from "../../services/api.service";
import Global from "../../common/global";

export default function PersonalDetailStep({
  languages,
  currentStep,
  taxNumberIN,
  locationData,
  inputPersonalEl,
  stepNo,
  inputFields,
  personalDetailsSubmit,
  inputChange,
  inputPhoneChange,
  onFieldBlur,
  emailChecking,
  goPreviousStep,
  isStepProcessing,
  checkMemberExist,
  isProcessing,
  goNextStep,
  isDisabled,
  products,
  localStorageDatas,
  couponObj,
  translationKey,
  salutationOverride,
  setInputFields,
  setStep,
  handleOnUpdateAddress,
  setIsPrimaryPostalRequired,
}) {

  const salutationOverrideHandler = (title) => {
    salutationOverride(title);
  }
  const setInputFieldHandler = (fields) => {
    setInputFields(fields);
  }
  const setStepHandler = (step) => {
    setStep(step);
  }
  const primaryCountryOfSelection = inputFields.filter(
    (a) => a.name === "country",
  );
  const primaryCountry = Global.CODED_COUNTRY_LIST.filter(
    (a) => a.name === primaryCountryOfSelection[0].value,
  );
  // useEffect to auto-check email
  useEffect(() => {
    if (currentStep === 2) {
      const autoCheckEmail = () => {
        const emailField = inputFields.find(
          (field) => field.name === "email",
        )?.value;

        if (emailField) {
          checkMemberExist({ email: emailField });
        }
      };
      autoCheckEmail();
    }
  }, [currentStep]);

  const fetchLocalStorageData = useCallback(async () => {
    const ssoUser = await ApiService.userdata();
    const personalData = window.sessionStorage.getItem("personal_details");

    const personalDetails = {
      email: ssoUser.email,
      title: salutationOverrideHandler(ssoUser.title),
      first_name: ssoUser.first_name,
      last_name: ssoUser.last_name,
      phone_number: {
        leahNum: ssoUser.phonePrefix + ssoUser.phoneNumber,
        inputVal: ssoUser.phonePrefix + ssoUser.phoneNumber,
      },
      country: primaryCountry[0]?.iso,
      postal_code: ssoUser.address?.zipCode,
    };

    if (personalData) {
      const storageLocalPersonalData = JSON.parse(personalData);

      const storedData = inputFields.map((field) => ({
        ...field,
        value: storageLocalPersonalData[field.name] || field.value, // Use personal data if available
      }));

      setInputFieldHandler(storedData);
    } else {
      // Populate fields with SSO data if personal details are not found in sessionStorage
      const ssoDataFields = inputFields.map((field) => ({
        ...field,
        value: personalDetails[field.name] || field.value, // Use SSO data if available
      }));

      setInputFieldHandler(ssoDataFields);
    }

    return () => {
      setInputFieldHandler(null);
    };
  }, []);

  useEffect(() => {
    const getUserTokenData = Cookies.get("allUserData");
    if (getUserTokenData) {
      fetchLocalStorageData();
      setStepHandler(2);
    }
    return () => {
      console.log("fetch data successfully!");
    };
  }, [fetchLocalStorageData]);


  const countrySelectionStep = currentStep === 2
  const countrySelectionValue = primaryCountryOfSelection[0].value;


  useEffect(() => {
    if (primaryCountryOfSelection) {

      let countryCode =
        primaryCountry[0] === undefined ? "us" : primaryCountry[0].code;
      handleOnUpdateAddress(
        "state",
        { country: countryCode },
        primaryCountry,
        setIsPrimaryPostalRequired,
      );
    }
  }, [countrySelectionValue, countrySelectionStep]);

  if (currentStep !== stepNo) {
    return null;
  }

  const memberFirst = inputFields.find(
    (field) => field.name === "first_name",
  )?.value;
  const memberLast = inputFields.find(
    (field) => field.name === "last_name",
  )?.value;

  const isUserLoggedIn =
    Cookies.get("accorUserData") || Cookies.get("allUserData");

  return (
    <Layout>
      <ErrorBoundary>
        {/* Grid Layout for CardAsset and Form */}
        <div className="grid grid-cols-1 tablet:grid-cols-2 tablet:gap-4">
          {/* Left Column: CardAsset */}
          <div className="flex flex-col mx-auto xs:mx-0">
            <BackButton goPreviousStep={goPreviousStep} />
            <CardAsset />
          </div>

          {/* Right Column: Form */}
          <div className="xs:flex xs:justify-center xs:flex-col w-[420px] xs:w-auto">
            <StepsIndicator
              step={currentStep}
              stepText={
                languages && languages.stepTitle2
                  ? languages.stepTitle2
                  : "Contact Details"
              }
              subTitleHeader={
                languages && languages.yourContactDetails
                  ? languages.yourContactDetails
                  : "Your contact details"
              }
              languages={languages}
            />

            {!isUserLoggedIn ? (
              <AllLoginNotification languages={languages} />
            ) : null}

            <form
              id="personal-details"
              className="tablet:px-4 input-borders py-4 xs:w-full mt-5"
            >
              <InputFields
                languages={languages}
                inputFields={inputFields}
                inputChange={inputChange}
                inputPhoneChange={inputPhoneChange}
                onFieldBlur={onFieldBlur}
                inputEl={inputPersonalEl}
                locationData={locationData}
                taxNumberIN={taxNumberIN}
                emailChecking={emailChecking}
              />
            </form>
            <NextButton
              isProcessing={isProcessing || isStepProcessing}
              goNextStep={personalDetailsSubmit}
              languages={languages}
              isDisabled={isDisabled}
            />
          </div>
        </div>
      </ErrorBoundary>
    </Layout>
  );
}
